export class PaymentCenterModalController {

  constructor($scope, $modalInstance) {
    $scope.vm = this;
    this.scope = $scope;

    this.scope.cancel = () => {
      $modalInstance.dismiss('cancel');
    };
  }
}
